// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const HookCustomScreen = lazy(() => import('pages/screens/Screens'));

const HookCustomScreenRoute = (
  <Route path={routeName.hookCustomScreens}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.HOOK_INSTANCE_VIEW,
            PrivateRouteConst.SELF_HOOK_INSTANCE_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <HookCustomScreen />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default HookCustomScreenRoute;
